export default "__VITE_ASSET__Dfcpm$o___"